<!--
  ~ Copyright (C) 2019 - Potentially Ltd
  ~
  ~ Please see distribution for license.
-->

<div class="box">
  <div class="skeleton__text skeleton__text--90 skeleton__text--margin slide-row"></div>
  <div class="skeleton__text skeleton__text--50 skeleton__text--margin slide-row"></div>
  <div class="skeleton__text skeleton__text--90 skeleton__text--margin slide-row"></div>
  <div class="skeleton__text skeleton__text--90 skeleton__text--margin slide-row"></div>
  <div class="skeleton__text skeleton__text--30 skeleton__text--margin slide-row"></div>
  <div class="skeleton__text skeleton__text--90 skeleton__text--margin slide-row"></div>
  <div class="skeleton__text skeleton__text--70 skeleton__text--margin slide-row"></div>
  <div class="skeleton__text skeleton__text--90 skeleton__text--margin slide-row"></div>
  <div class="skeleton__text skeleton__text--90 skeleton__text--margin slide-row"></div>
  <div class="skeleton__text skeleton__text--70 skeleton__text--margin slide-row"></div>
  <div class="skeleton__text skeleton__text--70 skeleton__text--margin slide-row"></div>
  <div class="skeleton__text skeleton__text--30 skeleton__text--margin slide-row"></div>
</div>
<div class="box">
  <div class="skeleton__text skeleton__text--90 skeleton__text--margin slide-row"></div>
  <div class="skeleton__text skeleton__text--50 skeleton__text--margin slide-row"></div>
  <div class="skeleton__text skeleton__text--90 skeleton__text--margin slide-row"></div>
  <div class="skeleton__text skeleton__text--90 skeleton__text--margin slide-row"></div>
  <div class="skeleton__text skeleton__text--30 skeleton__text--margin slide-row"></div>
  <div class="skeleton__text skeleton__text--90 skeleton__text--margin slide-row"></div>
  <div class="skeleton__text skeleton__text--70 skeleton__text--margin slide-row"></div>
  <div class="skeleton__text skeleton__text--90 skeleton__text--margin slide-row"></div>
  <div class="skeleton__text skeleton__text--90 skeleton__text--margin slide-row"></div>
  <div class="skeleton__text skeleton__text--70 skeleton__text--margin slide-row"></div>
  <div class="skeleton__text skeleton__text--70 skeleton__text--margin slide-row"></div>
  <div class="skeleton__text skeleton__text--30 skeleton__text--margin slide-row"></div>
</div>
<div class="box">
  <div class="skeleton__text skeleton__text--90 skeleton__text--margin slide-row"></div>
  <div class="skeleton__text skeleton__text--50 skeleton__text--margin slide-row"></div>
  <div class="skeleton__text skeleton__text--90 skeleton__text--margin slide-row"></div>
  <div class="skeleton__text skeleton__text--90 skeleton__text--margin slide-row"></div>
  <div class="skeleton__text skeleton__text--30 skeleton__text--margin slide-row"></div>
  <div class="skeleton__text skeleton__text--90 skeleton__text--margin slide-row"></div>
  <div class="skeleton__text skeleton__text--70 skeleton__text--margin slide-row"></div>
  <div class="skeleton__text skeleton__text--90 skeleton__text--margin slide-row"></div>
  <div class="skeleton__text skeleton__text--90 skeleton__text--margin slide-row"></div>
  <div class="skeleton__text skeleton__text--70 skeleton__text--margin slide-row"></div>
  <div class="skeleton__text skeleton__text--70 skeleton__text--margin slide-row"></div>
  <div class="skeleton__text skeleton__text--30 skeleton__text--margin slide-row"></div>
</div>
